
































































































































































































import Vue from 'vue';
import config from '@/config/index';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { IEtiqueta } from '@/interfaces/Etiquetas';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { ITipoActividad } from '@/interfaces/TipoActividad';
import { ServicioProxy, HomeFiltros } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import moment, { Duration } from 'moment';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Validator } from 'vee-validate';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import store from '@/store';
import ContactosNotificados from '@/components/plataforma/ContactosNotificados.vue';
import DetalleNotificacion from '@/components/plataforma/DetalleNotificacion.vue';

import { fetchAlertas } from '@/pantallas/Alertas/Services/fetchAlertas';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    ContactosNotificados,
    DetalleNotificacion,
    DatePicker,
    TimePicker,
  },
})
export default class Notificaciones extends ComponenteBaseStepper {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Notificaciones;
  permisosActuales: PermisoAccionVm[] = [];

  permisosTotales: PermisoAccionVm[] = [];

  //Variables globales
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  tabModel: string = '0';

  columnDefsAlertas: Array<ColDef> = [];
  gridOptions: GridOptions;
  sideBar: any = config.agGridDefaultConfig; //
  localeText: any = config.agGridTextos; //
  alertasRespaldo: any[] = [];
  buscarAlertaMes: string = '';
  buscarAlertaAnio: string = '';
  isNoData: boolean = false;
  dictionaryFormErrors: any = {};
  buscarAlerta: any[] = [];
  validForm: boolean = false;
  usuarioId: number = store.state.userId;
  filtroMes: string = '';
  filtroAnio: string = '';
  alertaColor: string[] = [];
  filtroTipoAlerta: string = '';
  Colores: string[] = ['Amarilla', 'Roja', 'Verde'];
  buscarAlertaPatente: string[] = [];
  alertaNombre: string[] = [];
  checkAll: boolean = false;
  Vehiculo: string[] = [];
  fechaDesde: any = '';
  fechaHasta: any = '';
  horaDesde: any = '';
  checkAllColor: boolean = false;
  horaHasta: any = '';
  gridApi: GridApi;
  columnApi: ColumnApi;
  agGridUtil: AgGridUtil;
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;
  $snotify: any;
  muestraNotificados: boolean = false;
  muestraDetalleNotificacion: boolean = false;
  idNotificacion: number = 0;
  checkAllAlerta: boolean = false;
  //AXIOS
  axiosNotificacion: AxiosVue = new AxiosVue(ServicioProxy.Notificacion);
  axiosPython: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  axiosVehiculo: AxiosVue = new AxiosVue(ServicioProxy.Vehiculo);

  meses: any[] = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  async mounted() {
    this.tabModel = '0';
    this.initialize();
    this.buscarAlerta = await this.fetchAlertas();
    this.getVehiculos();
    this.fechaDesde = this.getYesterdayDate();
    this.fechaHasta = this.getYesterdayDate();
    this.horaDesde = moment('00:00:00', 'HH:mm:ss');
    this.horaHasta = moment('23:59:59', 'HH:mm:ss');
  }

  getYesterdayDate() {
    // Crear un objeto Moment para la fecha de ayer
    return moment().subtract(1, 'days');
  }

  async getVehiculos(): Promise<void> {
    try {
      const response = await this.axiosVehiculo.http.get(
        `Vehiculo/${this.clienteId}/vehiculosCliente`
      );
      this.Vehiculo = response.data.sort((a: any, b: any) => {
        return a.unidad.localeCompare(b.unidad);
      });
    } catch (error) {
      console.log(error);
    }
  }
  get fechaMaxima() {
    const today = new Date();
    let fechaMax =
      today.getFullYear() +
      '-' +
      this.setCeros((today.getMonth() + 1).toString()) +
      '-' +
      this.setCeros(today.getDate().toString());

    return fechaMax;
  }
  setCeros(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  valideListPatent() {
    if (this.buscarAlertaPatente.length < this.Vehiculo.length) {
      this.checkAll = false;
    } else {
      this.checkAll = true;
    }
  }

  valideListAlert() {
    if (this.alertaNombre.length < this.buscarAlerta.length) {
      this.checkAllAlerta = false;
    } else {
      this.checkAllAlerta = true;
    }
  }

  selectAllAlerta() {
    if (this.checkAllAlerta === true) {
      this.buscarAlerta.forEach((x: any) => {
        const existe: boolean = this.alertaNombre.some(a => a === x);
        if (existe === false) {
          this.alertaNombre.push(x.nombre);
        }
      });
    } else {
      this.alertaNombre = [];
    }
  }
  selectAll() {
    if (this.checkAll === true) {
      this.Vehiculo.forEach((x: any) => {
        const existe: boolean = this.buscarAlertaPatente.some(a => a === x.id);
        if (existe === false) {
          this.buscarAlertaPatente.push(x.id);
        }
      });
    } else {
      this.buscarAlertaPatente = [];
    }
  }
  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        anio: {
          max: () => '* Formato de Año inválido.',
          min_value: () => '* Formato de Año inválido.',
          integer: () => '* Formato de Año inválido.',
          numeric: () => '* Formato de Año inválido.',
        },
      },
    };

    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  selectAllColor() {
    if (this.checkAllColor === true) {
      this.Colores.forEach((x: any) => {
        const existe: boolean = this.alertaColor.some(a => a === x);
        if (existe === false) {
          this.alertaColor.push(x);
        }
      });
    } else {
      this.alertaColor = [];
    }
  }

  constructor() {
    super();
    this.estadoGrillaVm = {
      id: 0,
      grilla: '',
      usuarioId: this.usuarioId,
      funcionalidades: this.funcionalidad,
    };

    this.columnDefsAlertas = [
      {
        headerName: 'Color de Tipificación',
        field: 'color',
        width: 200,
        minWidth: 200,
        filter: false,
        suppressMovable: true,
        sortable: false,
        resizable: true,
        enablePivot: false,
        lockVisible: true,
        pinned: 'left',
        lockPosition: true,
        cellRenderer: this.createIconC,
      },
      {
        headerName: 'Fecha/Hora',
        field: 'fechaInicio',
        lockPinned: true,
        width: 200,
        minWidth: 200,
        enablePivot: true,
        resizable: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Unidad',
        field: 'unidad',
        lockPinned: true,
        width: 300,
        minWidth: 300,
        enablePivot: true,
        resizable: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Mensaje',
        field: 'mensaje',
        lockPinned: true,
        width: 250,
        minWidth: 250,
        enablePivot: true,
        resizable: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },

      {
        headerName: 'Tipificación',
        field: 'tipificacion',
        lockPinned: true,
        width: 250,
        minWidth: 250,
        enablePivot: true,
        resizable: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: params => {
          let tipificacion = '';
          switch (params.data.color) {
            case 'Amarilla':
              tipificacion = 'Media';
              break;
            case 'Verde':
              tipificacion = 'Baja';
              break;
            case 'Roja':
              tipificacion = 'Crítica';
              break;
            default:
              tipificacion = 'Desconocido';
          }
          return tipificacion;
        },
      },
      // Se ocultan mientras se pasan las mejoras en los servicios de notificacion
      // {
      //   headerName: 'Contactos Notificados',
      //   field: '',
      //   lockPinned: true,
      //   width: 200,
      //   minWidth: 200,
      //   enablePivot: true,
      //   resizable: true,
      //   cellStyle: { textAlign: 'left' },
      //   cellRenderer: this.createContactosBtn,
      // },
      // {
      //   headerName: 'Detalle Notificación',
      //   field: '',
      //   lockPinned: true,
      //   width: 200,
      //   minWidth: 200,
      //   enablePivot: true,
      //   resizable: true,
      //   cellStyle: { textAlign: 'left' },
      //   cellRenderer: this.createDetalleBtn,
      // },
      {
        headerName: 'Mapa',
        field: 'mapa',
        suppressMovable: true,
        minWidth: 80,
        width: 150,
        enablePivot: true,
        resizable: true,
        lockVisible: true,
        pinned: 'right',
        cellRenderer: this.createMapaBtn,
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      cacheBlockSize: 10000, //Solución Paginación
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      localeText: this.localeText,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefsAlertas,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      onDragStopped: this.onDragStoppedEvent,
      onColumnVisible: this.onColumnVisibleEvent,
      onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
    };

    this.tabModel = '0';
  }

  /*Grilla */
  onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    const self = this;
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    this.agGridUtil = new AgGridUtil(
      this.gridApi,
      this.columnApi,
      this.estadoGrillaVm
    );

    this.serverSide = {
      getRows(params: any): void {
        params.request.paginationSize = self.gridOptions.cacheBlockSize; //Solución Paginación
        params.request.tipo = self.tabModel;
        params.request.alertaNombre = self.filtroTipoAlerta;
        params.request.color = self.alertaColor;
        params.request.unidad = self.buscarAlertaPatente;
        params.request.alertaNombre = self.alertaNombre;
        moment().subtract(1, 'days');
        params.request.fechaInicio =
          moment(self.fechaDesde).format('YYYY-MM-DD ') +
          moment(self.horaDesde).format('HH:mm:ss');
        params.request.fechaFin =
          moment(self.fechaHasta).format('YYYY-MM-DD ') +
          moment(self.horaHasta).format('HH:mm:ss');
        params.request.clienteId = self.clienteId;
        console.log(params.request);
        self.axiosPython.http
          .post(
            `Metabase/PostgenericA/notificaciones_alertas_track/grid`,
            params.request
          )
          .then(gps => {
            if (gps.data.data.length === 0) {
              self.gridApi.showNoRowsOverlay();
              params.successCallback([{}], 0);
            } else {
              self.gridApi.hideOverlay();
              params.successCallback(gps.data.data, gps.data.lastRow);
            }
            self.loadingService.hideLoading();
          })
          .catch(err => {
            params.failCallback();
            self.loadingService.hideLoading();
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  async fetchAlertas() {
    this.loadingService.showLoading();
    try {
      // Obtener los datos y esperar a que la promesa se resuelva
      const alertas = await fetchAlertas();
      // Ordenar los resultados por la propiedad 'nombre'
      return alertas.sort((a, b) => a.nombre.localeCompare(b.nombre));
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error al intentar obtener las Alertas',
        { timeout: 3000 }
      );
      return []; // Devolver un array vacío en caso de error
    } finally {
      this.loadingService.hideLoading();
    }
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  onDragStoppedEvent(event: DragStoppedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onColumnVisibleEvent(event: ColumnVisibleEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  onColumnPinnedEvent(event: ColumnPinnedEvent) {
    this.agGridUtil.guardarEstadoGrilla();
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  onFilterTextBoxChanged() {
    let flagMes: boolean = this.validaNulo(this.buscarAlertaMes);
    let flagA: boolean = this.validaNulo(this.buscarAlertaAnio);
    if (flagMes || flagA) {
      this.gridApi.onFilterChanged();
    } else if (!flagMes && !flagA) {
      this.gridApi.setServerSideDatasource(this.serverSide);
    }
  }

  clearFilters() {
    this.fechaDesde = '';
    this.fechaHasta = '';
    this.horaDesde = '';
    this.horaHasta = '';
    this.buscarAlertaMes = '';
    this.buscarAlertaAnio = '';
    this.alertaNombre = [];
    this.buscarAlertaPatente = [];
    this.alertaColor = [];
    this.loadingService.showLoading();
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  validaNulo(item: any): boolean {
    if (item !== null && item !== undefined) return true;
    else return false;
  }

  createFechaIcon(params: any) {
    if (params.data !== undefined) {
      var newFecha = new Date(params.data.fechaTermino);
      if (newFecha.getFullYear() !== 1900) {
        return moment(String(newFecha)).format('DD/MM/YYYY HH:mm:ss');
      } else {
        return '';
      }
    }
  }

  async cargaNotificaciones() {
    this.clienteId = config.getClienteSesion();
    let cont = 0;
    this.loadingService.showLoading();
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  createIconC(params: any) {
    if (params.data.color !== undefined) {
      var eSpan = document.createElement('i');
      eSpan.className = 'material-icons';
      eSpan.id = params.data.id;
      eSpan.innerHTML = 'fiber_manual_record';
      let color = params.data.color;
      if (color === 'Roja') {
        eSpan.title = 'Roja';
        eSpan.style.cssText = 'cursor:pointer;color:red;font-size: 40px;';
      } else if (color === 'Verde') {
        eSpan.title = 'Verde';
        eSpan.style.cssText = 'cursor:pointer;color:green;font-size: 40px;';
      } else {
        eSpan.title = 'Amarilla';
        eSpan.style.cssText = 'cursor:pointer;color:yellow;font-size: 40px;';
      }
      return eSpan;
    }
  }

  createMapaBtn(params: any) {
    var eSpan = document.createElement('i');
    eSpan.innerHTML = 'map';
    eSpan.className = 'material-icons';
    eSpan.id = params.data.id;
    eSpan.style.cssText =
      'cursor:pointer;color:#27488E;font-size: 25px;padding-top:10px;';
    eSpan.title = 'Ver Mapa';

    eSpan.addEventListener('click', () => {
      var latitud = params.data.latitudInicioExceso;
      var longitud = params.data.longitudInicioExceso;
      this.openDetalle(latitud, longitud);
    });
    return eSpan;
  }

  createContactosBtn(params: any) {
    var eSpan = document.createElement('i');
    eSpan.innerHTML = 'VER >';
    eSpan.id = params.data.id;
    eSpan.style.cssText = 'cursor:pointer;color:#000000;font-size: 13px;';
    eSpan.title = 'Ver Contactos Notificados';

    eSpan.addEventListener('click', () => {
      this.mostrarNotificados(params.data.id);
    });
    return eSpan;
  }

  mostrarNotificados(idNotificacion: number) {
    this.muestraNotificados = true;
    this.idNotificacion = idNotificacion;
  }

  notificadosModalCallback() {
    this.muestraNotificados = false;
  }

  createDetalleBtn(params: any) {
    var eSpan = document.createElement('i');
    eSpan.innerHTML = 'VER >';
    eSpan.id = 'det' + params.data.id;
    eSpan.style.cssText = 'cursor:pointer;color:#000000;font-size: 13px;';
    eSpan.title = 'Ver Detalle Notificación';

    eSpan.addEventListener('click', () => {
      this.mostrarDelletaNotificacion(params.data.id);
    });
    return eSpan;
  }

  mostrarDelletaNotificacion(idNotificacion: number) {
    this.muestraDetalleNotificacion = true;
    this.idNotificacion = idNotificacion;
  }

  detallesModalCallback() {
    this.muestraDetalleNotificacion = false;
  }

  openDetalle(latitud: string, longitud: string) {
    var link =
      'https://www.google.com/maps/search/?api=1&query=' +
      latitud +
      ',' +
      longitud;
    window.open(link, '_blank');
  }

  beforeDestroy() {
    this.agGridUtil.guardarEstadoGrilla().finally(() => {
      this.gridApi.destroy();
    });
  }
}
